// extracted by mini-css-extract-plugin
export var container = "styles-module--container--55298";
export var gatsbyImage = "styles-module--gatsbyImage--ba26c";
export var image = "styles-module--image--a827b";